"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _Folder = _interopRequireDefault(require("./assets/Folder"));
var _Chrome = _interopRequireDefault(require("./assets/Chrome"));
var _Http = _interopRequireDefault(require("./assets/Http"));
var _Firefox = _interopRequireDefault(require("./assets/Firefox"));
var _ChevronClosed = _interopRequireDefault(require("./assets/ChevronClosed"));
var _ChevronOpen = _interopRequireDefault(require("./assets/ChevronOpen"));
var _GreenLock = _interopRequireDefault(require("./assets/GreenLock"));
var _Sun = _interopRequireDefault(require("./assets/Sun"));
var _Moon = _interopRequireDefault(require("./assets/Moon"));
var _Slack = _interopRequireDefault(require("./assets/Slack"));
var _Opsgenie = _interopRequireDefault(require("./assets/Opsgenie"));
var _Pagerduty = _interopRequireDefault(require("./assets/Pagerduty"));
var _Google = _interopRequireDefault(require("./assets/Google"));
var _GoogleChat = _interopRequireDefault(require("./assets/GoogleChat"));
var _Telegram = _interopRequireDefault(require("./assets/Telegram"));
var _ChevronDown = _interopRequireDefault(require("./assets/ChevronDown"));
var _Twilio = _interopRequireDefault(require("./assets/Twilio"));
var _Ok = _interopRequireDefault(require("./assets/Ok"));
var _Warning = _interopRequireDefault(require("./assets/Warning"));
var _WarningOutlined = _interopRequireDefault(require("./assets/WarningOutlined"));
var _OutageOutlined = _interopRequireDefault(require("./assets/OutageOutlined"));
var _Close = _interopRequireDefault(require("./assets/Close"));
var _Unplug = _interopRequireDefault(require("./assets/Unplug"));
var _Copy = _interopRequireDefault(require("./assets/Copy"));
var _Check = _interopRequireDefault(require("./assets/Check"));
var _Home = _interopRequireDefault(require("./assets/Home"));
var _Collection = _interopRequireDefault(require("./assets/Collection"));
var _Users = _interopRequireDefault(require("./assets/Users"));
var _Bell = _interopRequireDefault(require("./assets/Bell"));
var _Lock = _interopRequireDefault(require("./assets/Lock"));
var _Login = _interopRequireDefault(require("./assets/Login"));
var _StatusOnline = _interopRequireDefault(require("./assets/StatusOnline"));
var _CheckCircle = _interopRequireDefault(require("./assets/CheckCircle"));
var _XCircle = _interopRequireDefault(require("./assets/XCircle"));
var _Gear = _interopRequireDefault(require("./assets/Gear"));
var _Adjustments = _interopRequireDefault(require("./assets/Adjustments"));
var _Template = _interopRequireDefault(require("./assets/Template"));
var _Cloud = _interopRequireDefault(require("./assets/Cloud"));
var _CodeBracket = _interopRequireDefault(require("./assets/CodeBracket"));
var _MobilePhone = _interopRequireDefault(require("./assets/MobilePhone"));
var _Zap = _interopRequireDefault(require("./assets/Zap"));
var _Hyperping = _interopRequireDefault(require("./assets/Hyperping"));
var _Search = _interopRequireDefault(require("./assets/Search"));
var _Refresh = _interopRequireDefault(require("./assets/Refresh"));
var _ExternalLink = _interopRequireDefault(require("./assets/ExternalLink"));
var _BadgeCheck = _interopRequireDefault(require("./assets/BadgeCheck"));
var _Terminal = _interopRequireDefault(require("./assets/Terminal"));
var _ChevronRight = _interopRequireDefault(require("./assets/ChevronRight"));
var _ChevronLeft = _interopRequireDefault(require("./assets/ChevronLeft"));
var _Globe = _interopRequireDefault(require("./assets/Globe"));
var _Fire = _interopRequireDefault(require("./assets/Fire"));
var _DotsHorizontal = _interopRequireDefault(require("./assets/DotsHorizontal"));
var _DotsVertical = _interopRequireDefault(require("./assets/DotsVertical"));
var _Drag = _interopRequireDefault(require("./assets/Drag"));
var _Plus = _interopRequireDefault(require("./assets/Plus"));
var _Trash = _interopRequireDefault(require("./assets/Trash"));
var _Eye = _interopRequireDefault(require("./assets/Eye"));
var _EyeOff = _interopRequireDefault(require("./assets/EyeOff"));
var _Document = _interopRequireDefault(require("./assets/Document"));
var _Cone = _interopRequireDefault(require("./assets/Cone"));
var _Minus = _interopRequireDefault(require("./assets/Minus"));
var _Puzzle = _interopRequireDefault(require("./assets/Puzzle"));
var _Wrench = _interopRequireDefault(require("./assets/Wrench"));
var _Keyframes = _interopRequireDefault(require("./assets/Keyframes"));
var _Teams = _interopRequireDefault(require("./assets/Teams"));
var _Discord = _interopRequireDefault(require("./assets/Discord"));
var _Webhook = _interopRequireDefault(require("./assets/Webhook"));
var _Helpdocs = _interopRequireDefault(require("./assets/Helpdocs"));
var _Wip = _interopRequireDefault(require("./assets/Wip"));
var _Key = _interopRequireDefault(require("./assets/Key"));
var _Speed = _interopRequireDefault(require("./assets/Speed"));
var _Twitter = _interopRequireDefault(require("./assets/Twitter"));
var _Calendar = _interopRequireDefault(require("./assets/Calendar"));
var _CalendarRange = _interopRequireDefault(require("./assets/CalendarRange"));
var _CircleHalf = _interopRequireDefault(require("./assets/CircleHalf"));
var _Clock = _interopRequireDefault(require("./assets/Clock"));
var _Edit = _interopRequireDefault(require("./assets/Edit"));
var _Bug = _interopRequireDefault(require("./assets/Bug"));
var _Sms = _interopRequireDefault(require("./assets/Sms"));
var _Email = _interopRequireDefault(require("./assets/Email"));
var _Heartbeat = _interopRequireDefault(require("./assets/Heartbeat"));
var _ArrowPath = _interopRequireDefault(require("./assets/ArrowPath"));
var _CrossSP = _interopRequireDefault(require("./assets/CrossSP"));
var _CheckSP = _interopRequireDefault(require("./assets/CheckSP"));
var _Tv = _interopRequireDefault(require("./assets/Tv"));
var _VideoCamera = _interopRequireDefault(require("./assets/VideoCamera"));
var _CornerLeftUp = _interopRequireDefault(require("./assets/CornerLeftUp"));
var _CornerDownRight = _interopRequireDefault(require("./assets/CornerDownRight"));
var _Cpu = _interopRequireDefault(require("./assets/Cpu"));
var _Pausecircle = _interopRequireDefault(require("./assets/Pausecircle"));
var _Menu = _interopRequireDefault(require("./assets/Menu"));
var _Target = _interopRequireDefault(require("./assets/Target"));
var _Siren = _interopRequireDefault(require("./assets/Siren"));
var _ArrowDownWideNarrow = _interopRequireDefault(require("./assets/ArrowDownWideNarrow"));
var _ArrowLeft = _interopRequireDefault(require("./assets/ArrowLeft"));
var _Pencil = _interopRequireDefault(require("./assets/Pencil"));
var _Info = _interopRequireDefault(require("./assets/Info"));
var _Fingerprint = _interopRequireDefault(require("./assets/Fingerprint"));
var _ShieldCheck = _interopRequireDefault(require("./assets/ShieldCheck"));
var _BookOpenText = _interopRequireDefault(require("./assets/BookOpenText"));
var _Filter = _interopRequireDefault(require("./assets/Filter"));
var _Phone = _interopRequireDefault(require("./assets/Phone"));
var _PhoneCall = _interopRequireDefault(require("./assets/PhoneCall"));
var _Schedule = _interopRequireDefault(require("./assets/Schedule"));
var _Ghost = _interopRequireDefault(require("./assets/Ghost"));
var _CreditCard = _interopRequireDefault(require("./assets/CreditCard"));
var _Megaphone = _interopRequireDefault(require("./assets/Megaphone"));
var _CheckFull = _interopRequireDefault(require("./assets/CheckFull"));
var _RoundMinus = _interopRequireDefault(require("./assets/RoundMinus"));
var _Link = _interopRequireDefault(require("./assets/Link"));
var _Medal = _interopRequireDefault(require("./assets/Medal"));
var _BadgeMinus = _interopRequireDefault(require("./assets/BadgeMinus"));
var _Download = _interopRequireDefault(require("./assets/Download"));
var _Unlink = _interopRequireDefault(require("./assets/Unlink"));
var _Signature = _interopRequireDefault(require("./assets/Signature"));
var _Hammer = _interopRequireDefault(require("./assets/Hammer"));
var _ShieldUser = _interopRequireDefault(require("./assets/ShieldUser"));
var _CircleAlert = _interopRequireDefault(require("./assets/CircleAlert"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// Mostly uses https://v1.heroicons.com
// Also: https://heroicons.com

const Icons = props => {
  const getSize = () => {
    if (props.size === 'small') return '12px';
    if (props.size === 'medium') return '16px';
    if (props.size === 'large') return '20px';
    return '15px';
  };
  const {
    name
  } = props;
  if (name === 'folder') return /*#__PURE__*/_react.default.createElement(_Folder.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'http') return /*#__PURE__*/_react.default.createElement(_Http.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'firefox') return /*#__PURE__*/_react.default.createElement(_Firefox.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'chrome') return /*#__PURE__*/_react.default.createElement(_Chrome.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'chevronclosed') return /*#__PURE__*/_react.default.createElement(_ChevronClosed.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'chevronopen') return /*#__PURE__*/_react.default.createElement(_ChevronOpen.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'chevrondown') return /*#__PURE__*/_react.default.createElement(_ChevronDown.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'greenlock') return /*#__PURE__*/_react.default.createElement(_GreenLock.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'lock') return /*#__PURE__*/_react.default.createElement(_Lock.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'sun') return /*#__PURE__*/_react.default.createElement(_Sun.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'moon') return /*#__PURE__*/_react.default.createElement(_Moon.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'slack') return /*#__PURE__*/_react.default.createElement(_Slack.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'opsgenie') return /*#__PURE__*/_react.default.createElement(_Opsgenie.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'pagerduty') return /*#__PURE__*/_react.default.createElement(_Pagerduty.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'google') return /*#__PURE__*/_react.default.createElement(_Google.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'googlechat') return /*#__PURE__*/_react.default.createElement(_GoogleChat.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'telegram') return /*#__PURE__*/_react.default.createElement(_Telegram.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'twilio') return /*#__PURE__*/_react.default.createElement(_Twilio.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'unlink') return /*#__PURE__*/_react.default.createElement(_Unlink.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'ok') return /*#__PURE__*/_react.default.createElement(_Ok.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'warning') return /*#__PURE__*/_react.default.createElement(_Warning.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'warningoutlined') return /*#__PURE__*/_react.default.createElement(_WarningOutlined.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'outageoutlined') return /*#__PURE__*/_react.default.createElement(_OutageOutlined.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'close') return /*#__PURE__*/_react.default.createElement(_Close.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'unplug') return /*#__PURE__*/_react.default.createElement(_Unplug.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'copy') return /*#__PURE__*/_react.default.createElement(_Copy.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'check') return /*#__PURE__*/_react.default.createElement(_Check.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'home') return /*#__PURE__*/_react.default.createElement(_Home.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'collection') return /*#__PURE__*/_react.default.createElement(_Collection.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'users') return /*#__PURE__*/_react.default.createElement(_Users.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'bell') return /*#__PURE__*/_react.default.createElement(_Bell.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'login') return /*#__PURE__*/_react.default.createElement(_Login.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'statusonline') return /*#__PURE__*/_react.default.createElement(_StatusOnline.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'checkcircle') return /*#__PURE__*/_react.default.createElement(_CheckCircle.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'circlealert') return /*#__PURE__*/_react.default.createElement(_CircleAlert.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'xcircle') return /*#__PURE__*/_react.default.createElement(_XCircle.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'gear') return /*#__PURE__*/_react.default.createElement(_Gear.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'adjustments') return /*#__PURE__*/_react.default.createElement(_Adjustments.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'template') return /*#__PURE__*/_react.default.createElement(_Template.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'cloud') return /*#__PURE__*/_react.default.createElement(_Cloud.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'codebracket') return /*#__PURE__*/_react.default.createElement(_CodeBracket.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'mobilephone') return /*#__PURE__*/_react.default.createElement(_MobilePhone.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'zap') return /*#__PURE__*/_react.default.createElement(_Zap.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'hyperping') return /*#__PURE__*/_react.default.createElement(_Hyperping.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'search') return /*#__PURE__*/_react.default.createElement(_Search.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'refresh') return /*#__PURE__*/_react.default.createElement(_Refresh.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'externallink') return /*#__PURE__*/_react.default.createElement(_ExternalLink.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'badgecheck') return /*#__PURE__*/_react.default.createElement(_BadgeCheck.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'terminal') return /*#__PURE__*/_react.default.createElement(_Terminal.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'chevronright') return /*#__PURE__*/_react.default.createElement(_ChevronRight.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'chevronleft') return /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'globe') return /*#__PURE__*/_react.default.createElement(_Globe.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'fire') return /*#__PURE__*/_react.default.createElement(_Fire.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'dotshorizontal') return /*#__PURE__*/_react.default.createElement(_DotsHorizontal.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'dotsvertical') return /*#__PURE__*/_react.default.createElement(_DotsVertical.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'drag') return /*#__PURE__*/_react.default.createElement(_Drag.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'plus') return /*#__PURE__*/_react.default.createElement(_Plus.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'trash') return /*#__PURE__*/_react.default.createElement(_Trash.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'eye') return /*#__PURE__*/_react.default.createElement(_Eye.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'eyeoff') return /*#__PURE__*/_react.default.createElement(_EyeOff.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'document') return /*#__PURE__*/_react.default.createElement(_Document.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'cone') return /*#__PURE__*/_react.default.createElement(_Cone.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'minus') return /*#__PURE__*/_react.default.createElement(_Minus.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'puzzle') return /*#__PURE__*/_react.default.createElement(_Puzzle.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'wrench') return /*#__PURE__*/_react.default.createElement(_Wrench.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'keyframes') return /*#__PURE__*/_react.default.createElement(_Keyframes.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'teams') return /*#__PURE__*/_react.default.createElement(_Teams.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'discord') return /*#__PURE__*/_react.default.createElement(_Discord.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'webhook') return /*#__PURE__*/_react.default.createElement(_Webhook.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'helpdocs') return /*#__PURE__*/_react.default.createElement(_Helpdocs.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'wip') return /*#__PURE__*/_react.default.createElement(_Wip.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'key') return /*#__PURE__*/_react.default.createElement(_Key.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'speed') return /*#__PURE__*/_react.default.createElement(_Speed.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'twitter') return /*#__PURE__*/_react.default.createElement(_Twitter.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'calendar') return /*#__PURE__*/_react.default.createElement(_Calendar.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'calendarrange') return /*#__PURE__*/_react.default.createElement(_CalendarRange.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'circlehalf') return /*#__PURE__*/_react.default.createElement(_CircleHalf.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'clock') return /*#__PURE__*/_react.default.createElement(_Clock.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'edit') return /*#__PURE__*/_react.default.createElement(_Edit.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'bug') return /*#__PURE__*/_react.default.createElement(_Bug.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'sms') return /*#__PURE__*/_react.default.createElement(_Sms.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'email') return /*#__PURE__*/_react.default.createElement(_Email.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'heartbeat') return /*#__PURE__*/_react.default.createElement(_Heartbeat.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'arrowpath') return /*#__PURE__*/_react.default.createElement(_ArrowPath.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'crosssp') return /*#__PURE__*/_react.default.createElement(_CrossSP.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'checksp') return /*#__PURE__*/_react.default.createElement(_CheckSP.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'tv') return /*#__PURE__*/_react.default.createElement(_Tv.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'videocamera') return /*#__PURE__*/_react.default.createElement(_VideoCamera.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'cornerleftup') return /*#__PURE__*/_react.default.createElement(_CornerLeftUp.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'cornerdownright') return /*#__PURE__*/_react.default.createElement(_CornerDownRight.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'cpu') return /*#__PURE__*/_react.default.createElement(_Cpu.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'pausecircle') return /*#__PURE__*/_react.default.createElement(_Pausecircle.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'menu') return /*#__PURE__*/_react.default.createElement(_Menu.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'target') return /*#__PURE__*/_react.default.createElement(_Target.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'siren') return /*#__PURE__*/_react.default.createElement(_Siren.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'escalationpolicy') return /*#__PURE__*/_react.default.createElement(_ArrowDownWideNarrow.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'arrowleft') return /*#__PURE__*/_react.default.createElement(_ArrowLeft.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'pencil') return /*#__PURE__*/_react.default.createElement(_Pencil.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'info') return /*#__PURE__*/_react.default.createElement(_Info.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'fingerprint') return /*#__PURE__*/_react.default.createElement(_Fingerprint.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'shieldcheck') return /*#__PURE__*/_react.default.createElement(_ShieldCheck.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'shielduser') return /*#__PURE__*/_react.default.createElement(_ShieldUser.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'bookopentext') return /*#__PURE__*/_react.default.createElement(_BookOpenText.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'filter') return /*#__PURE__*/_react.default.createElement(_Filter.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'phone') return /*#__PURE__*/_react.default.createElement(_Phone.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'phonecall') return /*#__PURE__*/_react.default.createElement(_PhoneCall.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'schedule') return /*#__PURE__*/_react.default.createElement(_Schedule.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'ghost') return /*#__PURE__*/_react.default.createElement(_Ghost.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'creditcard') return /*#__PURE__*/_react.default.createElement(_CreditCard.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'megaphone') return /*#__PURE__*/_react.default.createElement(_Megaphone.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'checkfull') return /*#__PURE__*/_react.default.createElement(_CheckFull.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'roundminus') return /*#__PURE__*/_react.default.createElement(_RoundMinus.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'link') return /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'medal') return /*#__PURE__*/_react.default.createElement(_Medal.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'badgeminus') return /*#__PURE__*/_react.default.createElement(_BadgeMinus.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'download') return /*#__PURE__*/_react.default.createElement(_Download.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'signature') return /*#__PURE__*/_react.default.createElement(_Signature.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  if (name === 'hammer') return /*#__PURE__*/_react.default.createElement(_Hammer.default, _extends({
    height: getSize(),
    width: getSize()
  }, props));
  return /*#__PURE__*/_react.default.createElement("div", null, "Icons");
};
var _default = exports.default = Icons;